import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IonSlides, NavController } from '@ionic/angular';
import { SlideService } from 'src/app/services/slide.service';
import { SponsorService } from 'src/app/services/sponsor.service';

@Component({
  selector: 'app-sponsors',
  templateUrl: './sponsors.component.html',
  styleUrls: ['./sponsors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SponsorsComponent implements OnInit, AfterViewInit {
  @Input() sponsors = undefined;
  @ViewChild('slidesSponsor') slidesSponsor: IonSlides;

  public sponsorImages: any[] = [];
  public fixedSponsor: any = {};
  public reachedEnd = false;
  public isStart = true;
  public slideOpts: any = {
    spaceBetween: 10,
    breakpoints: {
      220: {
        slidesPerView: 2.2,
      },
      420: {
        slidesPerView: 3.2,
      },
      520: {
        slidesPerView: 4,
      },
      800: {
        slidesPerView: 5,
      },
    },
  };

  constructor(
    private navCtrl: NavController,
    private sponsorSv: SponsorService,
    private slideSv: SlideService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.slideSv.comprobeCenter(this.sponsors, this.slideOpts);

    this.fixedSponsor = this.sponsors.sponsor;
    this.cdr.detectChanges();
  }
  launcherGoSponsor(event) {
    const id = event?.srcElement?.offsetParent?.dataset?.id || false;
    if (id) {
      const sponsor = this.fixedSponsor?.sponsors.filter(
        (s) => Number(s.id) === Number(id)
      );
      if (sponsor) {
        this.goSponsor(sponsor[0]);
      }
    }
  }
  async goSponsor(sponsor) {
    if (sponsor.galleriesCount || sponsor.productsCount) {
      if (sponsor.galleriesCount === 1) {
        await this.sponsorSv.getSponsor(sponsor.id);
      } else {
        await this.navCtrl.navigateForward(`sponsors/${sponsor.id}`);
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(async () => {
      this.reachedEnd = await this.slideSv.isEnd(this.slidesSponsor);
      this.cdr.markForCheck();
    });
  }

  async changedSlide(ev) {
    this.reachedEnd = ev.el.dom7ElementDataStorage.swiper.isEnd;
    if (!this.reachedEnd || this.reachedEnd) {
      this.isStart = ev.el.dom7ElementDataStorage.swiper.isBeginning;
    }
    this.cdr.markForCheck();
  }

  slideTo(direction: string) {
    direction == 'next'
      ? this.slidesSponsor.slideNext()
      : this.slidesSponsor.slidePrev();
  }
}
